import { FC, ReactElement } from "react";

interface IconImageProps {
  src: string;
  size?: string;
  style?: React.CSSProperties;
}

const IconImage: FC<IconImageProps> = ({
  src,
  size = "1rem",
  style,
}): ReactElement => {
  return (
    <img src={src} style={{ width: size, height: size, ...style }} alt="ico" />
  );
};

export default IconImage;
